import React from "react";
import NewUserForm from "../Components/UsersManagement/NewUser/NewUserForm";

function NewUser() {
  return (
    <div className="p-9">
      <NewUserForm />
    </div>
  );
}

export default NewUser;